// hooks/useViewport.js
import { useEffect, useState } from "react";

/**
 * Returns viewport (window) width/height and updates on resize/orientationchange.
 */
export default function useViewport() {
  const [state, setState] = useState(() => ({
    vw: window.innerWidth,
    vh: window.innerHeight,
  }));

  useEffect(() => {
    let raf = null;
    const update = () => {
      cancelAnimationFrame(raf);
      /**
       * Browser batches layout/paint per frame (~16ms at 60Hz)
       * By using requestAnimationFrame (RAF),
       * we are making sure the update is aligned with the repaint
       *  This reduces jank
       * By using RAF, we are making sure that even multiple events trigger this update within a frame (~16ms),
       * only the last event is registered
       *  We are avoiding flooding React with updates
       */
      raf = requestAnimationFrame(() => {
        setState({ vw: window.innerWidth, vh: window.innerHeight });
      });
    };

    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    update();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);

  return state;
}
